import {combineReducers} from 'redux'
import snackbar from './snackbar'
import api from './api'
import dialog from './dialog'
import confirmationDialog from './confirmationDialog'

export default combineReducers({
    snackbar,
    api,
    dialog,
    confirmationDialog
});



// WEBPACK FOOTER //
// ./src/reducers/ui/index.js